import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import { SVGAsset } from "res";
/**
 * @function UITextInput 
 * @param {STRING} value - Allows us to set the value of the text input. 
 * @param {STRING} placeholder - Allows us to set the placeholder text. 
 * @param {FUNCTION} onChange - Applies value of text field to event handler whenever text is changed :: STRING, EVENT -> VOID.
 * @param {STRING} data-point - The data point that should be applied to the input
 * @returns {React.Component}
 * @example
 * <UITextInput value="Some value" placeholder="Some placeholder" onChange={(value, evt)=> console.log(`${value} is now the value of text input`)} />
 */

export default function UITextInput(props) {
  const [ state, setState ] = useState(props.value ?? "");

  const ref = useRef();
  const placeholder = props.placeholder ?? "";
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
  const className = props.className ? { className:`"ui-text-input ${ props.className }-ui-text-input` } : { className: "ui-text-input" };

  const onChange = evt => props.onChange instanceof Function
    ? props.onChange(ref.current.value, evt)
    : setState(ref.current.value);
    const onFocus = evt => props.onFocus instanceof Function
    ? props.onFocus(ref.current.value, evt)
    : setState(ref.current.value);
    const onBlur = evt => props.onBlur instanceof Function
    ? props.onBlur(ref.current.value, evt)
    : setState(ref.current.value);
  useEffect(() => setState(props.value ?? ""), [ props.value ])
  let disabled = props.disabled ? {disabled:true}:{}; 
  const readOnly = props.readOnly ? { readOnly: true } : {};

  return (
    <input { ...readOnly } type="text" ref={ref} { ...className } value={ state }  placeholder={placeholder} onChange={ onChange } onFocus={onFocus} onBlur={onBlur} autoComplete="off" data-point={ point }  {...disabled}/>
  );
}

/**
 * @function UITextClearInput
 * @param {STRING} value - Allows us to set the value of the text input. 
 * @param {STRING} placeholder - Allows us to set the placeholder text. 
 * @param {FUNCTION} onChange - Applies value of text field to event handler whenever text is changed :: STRING, EVENT -> VOID.
 * @param {STRING} data-point - The data point that should be applied to the input
 * @returns {React.Component}
 * @example
 * <UITextClearInput value="Some value" placeholder="Some placeholder" onChange={(value, evt)=> console.log(`${value} is now the value of text input`)} />
 */
 export function UITextClearInput(props) {
  const point = props.dataPoint ?? "";
  // Set initalize state for the input and close
  const [ state, setState ] = useState({ "input" : props.value ?? "", "close" : false });
  
  // onChange :: STRING -> VOID
  // Update the state, and call the props.onClick function
  const onChange = value => {
      setState({ 
        "input" : value, 
        "close" : value.length > 0 
      });

      if(props.onChange instanceof Function) {
          props.onChange(value);
      }
  };
  let disabled = props.disabled ? {disabled:true}:{}; 
  // Update the state if the props.value has been changed
  useEffect(() => setState({ "input" : props.value, "close" : props.value ? props.value.length > 0 : false }), [ props.value ])

  return(
    <div className="ui-text-clear-input">
      <UITextInput value={ state.input } onChange={ onChange } onBlur={ props.onBlur } data-point={ point } {...disabled} />
      { state.close && <SVGAsset id="CloseX" className="clickable" onClick={ () => onChange("") } /> }
    </div>
  );
}